export const Announcement_Title = "Meine Nachrichten";
export const WorkingNow_Title = "Aktuell auf der Arbeit";
export const NewTeamMembers_Title = "Neue Mitglieder";
export const Task_Title = "Aufgaben";
export const News_Title = "Top Nachrichten";
export const Key_Title = "Key Metrics";
export const App_Title = "Meine Apps";
export const locale = "de-de"